import { Component } from "@angular/core";
import { NG_VALUE_ACCESSOR } from "@angular/forms";
import { InputFormFieldAdapter } from "../../adapters/input-form-field.adapter";
import { DateFormField } from "../../auto-form.type";
import { DatePicker } from "../../../input/date/picker/input-date-picker.component";

@Component({
    selector: "app-date-form-field",
    standalone: true,
    imports: [DatePicker],
    templateUrl: "./date-form-field.component.html",
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: DateFormFieldComponent,
            multi: true,
        },
    ],
})
export class DateFormFieldComponent extends InputFormFieldAdapter<DateFormField<any>> {}
